import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  List,
  ListItem
} from '@material-ui/core';
import emojes from '../../../../helpers/emojes';

import { useSelector, useDispatch } from 'react-redux';

import { getMealSelector } from '../../../../store/meal';

import _ from 'lodash';

import withAlert from '../../../../hoc/withAlert';

const useStyles = makeStyles(theme => ({
  nestedHead: {
    paddingLeft: theme.spacing(4)
  },
  nested: {
    paddingLeft: theme.spacing(6)
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  },
  listItemText: {
    fontSize: 13
  },
  listItemNumber: {
    fontSize: 13,
    fontWeight: 600
  }
}));

const Summary = props => {
  const { date, coupons } = props;
  const [dishes, setDishes] = React.useState(null);
  const mealData = useSelector(getMealSelector);


  useEffect(() => {
    let preparedDishes = {};
    preparedDishes['breakfast'] = [];
    preparedDishes['dinner'] = [];
    preparedDishes['supper'] = [];
    preparedDishes['bar'] = [];

    const keys = {
      2: 'breakfast',
      1: 'dinner',
      3: 'supper',
      4: 'bar',
    };

    if (coupons.length > 0) {
      coupons.forEach(coupon => {
        preparedDishes[keys[coupon.eating_id]].push(
          {...mealData.filter(m => m.id === coupon.meal_id)[0], amount:coupon.amount}
        );
      });

      setDishes(preparedDishes);
    }
  }, [coupons]);

  return (
    <Card style={{ marginBottom: 20 }}>
      {dishes && (
        <React.Fragment>
          {/* <CardHeader
      title={`Твой заказ на ${date} ${emojes.getRandomHeart()} ${emojes.getRandomHeart()}`}
      /> */}
          <Typography variant="h5" style={{ margin: 10 }} gutterBottom>
            {`Твой заказ на ${date} `}{' '}
            <span aria-hidden="true" role="img">
              {emojes.getRandomHeart()}
            </span>
            <span aria-hidden="true" role="img">
              {emojes.getRandomHeart()}
            </span>{' '}
          </Typography>

          <Divider />
          <CardContent>
            {dishes['breakfast'].length > 0 && (
              <React.Fragment>
                <Typography variant="h5" style={{ fontSize: 14 }}>
                  Завтрак
                </Typography>
                <List dense={true}>
                  {dishes['breakfast'].map(d => (
                    d.amount >0 && (
                    <ListItem key={`breakfast_${d.id}`}>
                      <Typography>{d.amount} {d.name}</Typography>
                    </ListItem>)
                  ))}
                </List>
              </React.Fragment>
            )}
            {dishes['dinner'].length > 0 && (
              <React.Fragment>
                <Typography variant="h5" style={{ fontSize: 14 }}>
                  Обед
                </Typography>
                <List dense={true}>
                  {dishes['dinner'].map(d => (
                    d.amount >0 && (
                    <ListItem key={`dinner_${d.id}`}>
                      <Typography>{d.amount} {d.name}</Typography>
                    </ListItem>)
                  ))}
                </List>
              </React.Fragment>
            )}
            {dishes['supper'].length > 0 && (
              <React.Fragment>
                <Typography variant="h5" style={{ fontSize: 14 }}>
                  Ужин
                </Typography>
                <List dense={true}>
                  {dishes['supper'].map(d => (
                    d.amount >0 && (
                    <ListItem key={`supper_${d.id}`}>
                      <Typography>{d.amount} {d.name}</Typography>
                    </ListItem>)
                  ))}
                </List>
              </React.Fragment>
            )}

        {/* {dishes['bar'].length > 0 && (
              <React.Fragment>
                <Typography variant="h5" style={{ fontSize: 14 }}>
                  Бар
                </Typography>
                <List dense={true}>
                  {dishes['bar'].map(d => (
                    d.amount >0 && (
                    <ListItem key={`bar_${d.id}`}>
                      <Typography>{d.amount} {d.name}</Typography>
                    </ListItem>)
                  ))}
                </List>
              </React.Fragment>
            )} */}

          </CardContent>
        </React.Fragment>
      )}
    </Card>
  );
};

export default withAlert(Summary);
